import { useMutation } from '@gogame/query';

import { createInfluencerChannel } from 'scenes/Influencers/InfluencersChannels/sources/influencersChannels';

import { create } from '../queryKeyFactory';

export const useCreateInfluencerChannel = () => {
  const createMutation = useMutation(create(), createInfluencerChannel, {
    successMessage: () => 'Influencer Channel created',
  });
  return [createMutation.mutateAsync, createMutation];
};
